<!-- Message List -->
<app-chat-message-list
  class="flex-1 overflow-hidden flex flex-col w-full h-full"
  [messages]="messages"
  (inlineReferenceClick)="graphModal.handleInlineReferenceClick($event)"
  (showAllResources)="graphModal.handleShowAllResources($event)">
</app-chat-message-list>

<!-- Input Area -->
<app-chat-input
  [isLoading]="isLoading"
  (sendMessage)="handleSendMessage($event)">
</app-chat-input>

<!-- Graph Viewer Modal -->
<app-graph-viewer
  [isOpen]="graphModal.isModalOpen"
  [isLoading]="graphModal.isGraphLoading"
  [graphNodes]="graphModal.graphNodes"
  [graphEdges]="graphModal.graphEdges"
  [selectedNode]="graphModal.selectedNode"
  [selectedEdge]="graphModal.selectedEdge"
  (close)="graphModal.closeModal()"
  (nodeClick)="graphModal.handleNodeClick($event)"
  (detailsClose)="graphModal.selectedNode = null"
  (edgeClick)="graphModal.handleEdgeClick($event)"
  (edgeDetailsClose)="graphModal.selectedEdge = null"
  (suggestChunkEdits)="chunkEditor.handleSuggestChunkEdits($event)"
  (editChunksDirectly)="chunkEditor.handleEditChunksDirectly($event)">
</app-graph-viewer>

<!-- Edit Chunks Modal -->
<app-edit-chunks-modal
  [isOpen]="chunkEditor.isEditChunksModalOpen"
  [chunks]="chunkEditor.chunksToEdit"
  [aiSuggested]="chunkEditor.aiSuggestedChunks"
  [isUpdatingChunks]="chunkEditor.isSavingChunks"
  [suggestionContext]="chunkEditor.suggestionContext"
  [isLoadingSuggestions]="chunkEditor.isAnalyzingChunks"
  [apiError]="chatState.error$ | async"
  (close)="chunkEditor.closeChunkEditor()"
  (save)="chunkEditor.handleSaveChunkUpdates($event)"
  (clearApiError)="chatState.setError(null)">
</app-edit-chunks-modal>
